<template>
  <a :href="post.url" class="p-2.5 pt-5 border-t-[5px] mb-10" :class="borderClass">
    <div class="relative block mb-9" :class="wideMode ? 'md:flex md:items-start' : ''">
      <div
        class="relative block"
        :class="[wideMode ? 'w-full md:max-w-[660px]' : 'w-full', post.thumbnail ? '' : 'h-8']"
      >
        <img
          v-if="post.thumbnail"
          :sizes="sizes"
          :srcset="srcset"
          :src="post.thumbnail.urls.default"
          :alt="post.thumbnail.alt_text ?? ''"
          class="w-full"
          width="660"
          height="371"
        />
        <div
          v-if="categories.length"
          :class="[bgClass, post.thumbnail ? 'bottom-0' : 'top-0']"
          class="absolute translate-y-[50%] flex items-center"
        >
          <div class="font-title text-xl text-left tracking-wider px-[10px] py-[6px]">
            {{ categoryNames }}
          </div>
          <svg
            version="1.1"
            viewBox="0 0 6.35 7.9375"
            xmlns="http://www.w3.org/2000/svg"
            class="absolute right-[1px] top-0 translate-x-full h-full"
          >
            <path d="m0 0 6.35 3.9688-6.35 3.9687z" :class="fillClass" />
          </svg>
        </div>
      </div>

      <div :class="wideMode ? 'md:pl-10 md:w-[360px]' : ''">
        <div
          class="
            block
            text-[2rem]
            md:text-5xl
            font-title
            text-gray-800
            mb-5
            leading-reduced
            md:leading-reduced
          "
          :class="wideMode ? 'mt-9 md:mt-5' : 'mt-9'"
        >
          {{ post.title }}
        </div>
        <div v-if="post.excerpt" class="prose prose-lg pb-5 mb-5 border-b border-gray-200">
          {{ post.excerpt }}
        </div>
        <div class="block underline text-lg font-medium">Read Article</div>
      </div>
    </div>
  </a>
</template>

<script>
import get from 'lodash/get';
import head from 'lodash/head';
import HasColors from '../../../mixins/HasColors';

export default {
  mixins: [HasColors],

  props: {
    post: {
      type: Object,
      required: true,
    },
    wide: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    categories() {
      return get(this.post, 'categories', []);
    },

    categoryNames() {
      return this.categories.map((category) => category.name).join(', ');
    },

    bgColor() {
      return this.bgColorFromSlug();
    },

    textColor() {
      return this.textColorFromSlug();
    },

    bgClass() {
      return `bg-${this.bgColor} text-${this.textColor}`;
    },

    fillClass() {
      return `fill-${this.bgColor}`;
    },

    borderClass() {
      return `border-${this.bgColor}`;
    },

    textClass() {
      return `text-${this.textColor}`;
    },

    wideMode() {
      return this.wide && this.post.thumbnail;
    },

    srcset() {
      if (!this.post.thumbnail) {
        return;
      }

      return `${this.post.thumbnail.urls.post_preview_493} 493w, ${this.post.thumbnail.urls.post_preview_660} 660w`;
    },

    sizes() {
      if (this.wide) {
        return '(max-width: 767px) 100vw, 660px';
      }

      return '(max-width: 767px) 100vw, 493px';
    },
  },
};
</script>
